import React from 'react';
import { Link } from 'react-router-dom';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-blue-600">
            Transfer Paneli
          </Link>
          <Link to="/login" className="text-sm text-blue-600 hover:underline">
            Giris Yap
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Gizlilik Politikasi</h1>
          <p className="text-sm text-gray-500 mb-8">Son guncelleme: 4 Subat 2026</p>

          <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Genel Bakis</h2>
              <p>
                Transfer Paneli olarak gizliliginize onem veriyoruz. Bu politika, kisisel verilerinizi
                nasil topladigimizi, kullandigimizi, sakladigimizi ve korudugumuzu aciklamaktadir.
                Hizmetlerimizi kullanarak bu politikayi kabul etmis sayilirsiniz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Topladigimiz Veriler</h2>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.1 Hesap Bilgileri</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Ad ve soyad</li>
                <li>E-posta adresi</li>
                <li>Telefon numarasi</li>
                <li>Sirket/organizasyon adi</li>
                <li>Fatura bilgileri</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.2 Operasyonel Veriler</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Transfer bilgileri (lokasyonlar, tarihler, yolcu bilgileri)</li>
                <li>Musteri ve tedarikci bilgileri</li>
                <li>Sofor ve arac bilgileri</li>
                <li>Odeme ve fatura gecmisi</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.3 Teknik Veriler</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>IP adresi</li>
                <li>Tarayici tipi ve surumu</li>
                <li>Cihaz bilgileri</li>
                <li>Erisim zamanlari ve suresi</li>
                <li>Sayfa goruntulenmeleri ve tiklamalar</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Verilerin Kullanimi</h2>
              <p>Topladigimiz verileri asagidaki amaclarla kullaniriz:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li><strong>Hizmet sunumu:</strong> Platform'un temel islevlerini saglamak</li>
                <li><strong>Hesap yonetimi:</strong> Hesabinizi olusturmak ve yonetmek</li>
                <li><strong>Iletisim:</strong> Onemli guncellemeler ve bildirimler gondermek</li>
                <li><strong>Destek:</strong> Teknik destek ve yardim saglamak</li>
                <li><strong>Guvenlik:</strong> Dolandiricilik ve yetkisiz erisimi onlemek</li>
                <li><strong>Iyilestirme:</strong> Hizmetlerimizi gelistirmek ve analiz etmek</li>
                <li><strong>Yasal yukumlulukler:</strong> Yasal gerekliliklere uymak</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Veri Paylasimi</h2>
              <p>Verilerinizi asagidaki durumlar disinda ucuncu taraflarla paylasmayiz:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li><strong>Hizmet saglayicilar:</strong> Hosting, e-posta, odeme isleme gibi hizmetler icin</li>
                <li><strong>Yasal zorunluluk:</strong> Mahkeme karari veya yasal talep durumunda</li>
                <li><strong>Is transferi:</strong> Sirket birlesme veya satin alma durumunda</li>
                <li><strong>Izninizle:</strong> Acik izninizi aldigimiz diger durumlar</li>
              </ul>
              <p className="mt-3">
                <strong>Not:</strong> Verilerinizi pazarlama amaciyla ucuncu taraflara satmiyoruz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Veri Guvenligi</h2>
              <p>Verilerinizi korumak icin asagidaki onlemleri aliyoruz:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>SSL/TLS sifreleme ile veri aktarimi</li>
                <li>Veritabaninda sifreleme</li>
                <li>Duzeli guvenlik denetimleri</li>
                <li>Erisim kontrolleri ve yetkilendirme</li>
                <li>Guvenlik olaylarina hizli mudahale</li>
                <li>Calisan egitimi ve farkindalik programlari</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Veri Saklama</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Hesap verileri: Hesabiniz aktif oldugu surece</li>
                <li>Islem gecmisi: Yasal saklama suresi boyunca (genellikle 10 yil)</li>
                <li>Log kayitlari: 1 yil</li>
                <li>Hesap kapatildiginda: Veriler 30 gun icinde silinir (yasal yukumlulukler haric)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Haklariniz</h2>
              <p>KVKK kapsaminda asagidaki haklara sahipsiniz:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li><strong>Erisim hakki:</strong> Hangi verilerinizi isledigimizi ogrenme</li>
                <li><strong>Duzeltme hakki:</strong> Yanlis verilerin duzeltilmesini isteme</li>
                <li><strong>Silme hakki:</strong> Verilerinizin silinmesini talep etme</li>
                <li><strong>Tasima hakki:</strong> Verilerinizi baska bir hizmete aktarma</li>
                <li><strong>Itiraz hakki:</strong> Veri islemesine itiraz etme</li>
                <li><strong>Kisitlama hakki:</strong> Veri islemesini sinirlandirma</li>
              </ul>
              <p className="mt-3">
                Bu haklarinizi kullanmak icin destek@transferpaneli.com adresinden bize ulasin.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Cerezler</h2>
              <p>Platform, asagidaki amaclarla cerezler kullanmaktadir:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li><strong>Zorunlu cerezler:</strong> Oturum yonetimi ve guvenlik</li>
                <li><strong>Islevsel cerezler:</strong> Tercihlerinizi hatirlamak</li>
                <li><strong>Analitik cerezler:</strong> Kullanim istatistikleri</li>
              </ul>
              <p className="mt-3">
                Tarayici ayarlarindan cerezleri yonetebilirsiniz, ancak bu Platform'un bazi ozelliklerini
                etkileyebilir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Cocuklarin Gizliligi</h2>
              <p>
                Platform 18 yas alti bireylere yonelik degildir. Bilerek 18 yas alti bireylerden
                kisisel veri toplamiyoruz. Eger boyle bir veri toplandigini fark ederseniz,
                lutfen bizi bilgilendirin.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Uluslararasi Veri Transferi</h2>
              <p>
                Verileriniz Turkiye disindaki sunucularda islenebilir. Bu durumda, verilerinizin
                korunmasi icin gerekli onlemleri aliriz ve uygun guvenceler saglariz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Politika Degisiklikleri</h2>
              <p>
                Bu gizlilik politikasini zaman zaman guncelleyebiliriz. Onemli degisiklikler
                e-posta yoluyla bildirilir. Guncel politikayi duzenli olarak kontrol etmenizi
                oneririz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">12. Iletisim</h2>
              <p>
                Gizlilik politikasiyla ilgili sorulariniz veya talepleriniz icin:
              </p>
              <div className="mt-3 bg-gray-50 p-4 rounded-lg">
                <p><strong>E-posta:</strong> destek@transferpaneli.com</p>
                <p className="mt-1"><strong>Veri Sorumlusu:</strong> Transfer Paneli</p>
              </div>
            </section>
          </div>

          {/* Back to Home */}
          <div className="mt-10 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 hover:text-blue-700"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Ana Sayfaya Don
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm text-gray-500">
          <p>&copy; 2026 Transfer Paneli. Tum haklari saklidir.</p>
          <div className="mt-2 space-x-4">
            <Link to="/terms" className="hover:text-blue-600">Kullanim Kosullari</Link>
            <Link to="/privacy" className="hover:text-blue-600">Gizlilik Politikasi</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
